import React, { forwardRef, useImperativeHandle } from 'react';
import { FormProvider } from 'react-hook-form';
import * as yup from 'yup';
import { ExtraFieldInternalValue } from '../extraFieldInternalValue';
import { useExtraFieldsFormValidation7 } from '../useExtraFieldsFormValidation7';
import {
  ExtraFieldsAreaContent7,
  Props as ExtraFieldsAreaContentProps,
} from './ExtraFieldsAreaContent7';
import { useExtraFieldsFormSimple7 } from './useExtraFieldsFormSimple7';

type Props = ExtraFieldsAreaContentProps & {
  onChange: (
    extraFields: ExtraFieldInternalValue[],
    recordTypeName: string | undefined,
  ) => void;
  values?: readonly ExtraFieldInternalValue[];
  recordTypeName: string | null;
};

export type ExtraFieldsAreaContentSimple7Ref = {
  triggerValidation: () => Promise<boolean>;
};

export const ExtraFieldsAreaContentSimple7 = forwardRef<
  ExtraFieldsAreaContentSimple7Ref,
  Props
>(({ onChange, values, recordTypeName, ...restProps }, ref) => {
  const { applyExtraFieldsValidationSchema } = useExtraFieldsFormValidation7({
    extraFieldFormInfos: restProps.formFields,
    contextParams: restProps.contextParams ?? [],
  });

  const validationSchema = applyExtraFieldsValidationSchema(yup.object());
  const { formMethods } = useExtraFieldsFormSimple7({
    values,
    recordTypeName,
    availableRecordTypes: restProps.availableRecordTypes,
    onChange,
    validationSchema,
    inputsMounted: restProps.formFields.length > 0,
  });

  const { trigger } = formMethods;
  useImperativeHandle(ref, () => ({ triggerValidation: trigger }), [trigger]);

  return (
    <FormProvider {...formMethods}>
      <ExtraFieldsAreaContent7 {...restProps} />
    </FormProvider>
  );
});

ExtraFieldsAreaContentSimple7.displayName = 'ExtraFieldsAreaContentSimple7';
